import React from 'react';
import moment from 'moment';
import numeral from 'numeral';
import { apiGet, apiPost } from '../../../../services/apiClient';
import { getRoles } from '../../../../services/userRights';
import ConfirmModal from '../../../../modals/confirmModal.jsx';
import InformationModal from '../../../../modals/infoModal.jsx';
import FillRecipientCompanyModal from '../../../../modals/fillRecipientCompanyModal.jsx';
import { isUndefined } from 'util';
import './costCalcTab.css';
import ResultData from "../resultData";
import SelectTariffModal from "../selectTariffModal";
import ActualCostBlock from '../actualCostBlock';

export default class CostCalcTab extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            busyCount: 0
        };

		this.confirmModal = null;
		this.infoModal = null;
		this.fillRecipientModal = null;
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

	initParcelData(parcel) {
		parcel.carrierPublicOfferUrl = null;
		parcel.carrierCostRequests = [];
        return parcel;
    }

	reloadReferences() {
        return this.handleRequestsChange(this.props.parcel.carrierCostRequests);
    }

	convertToResultEntry(entry) {
		return {
			carrierId: entry.carrierId,
			carrierServiceCode: entry.carrierServiceCode,
			carrierServiceName: entry.carrierServiceName,
			cost: entry.cost,
			rawCost: entry.rawCost,
			tariffRate: entry.tariffRate,
			minDeliveryTime: entry.minDeliveryTime,
			maxDeliveryTime: entry.maxDeliveryTime,
			deliveryTimeComment: entry.deliveryTimeComment,
			status: entry.status,
			statusComment: entry.statusComment,
			isSelected: entry.isSelected,
			claimId: entry.claimId,
			version: entry.version,
			tariff: entry.tariff,
			services: entry.services
		};
	}

    fillModel(parcel) {
		if (this.props.parcel.carrierCostRequests) {
			parcel.carrierCostRequests = this.props.parcel.carrierCostRequests.map((entry, ind, arr) => this.convertToResultEntry(entry));
		}
        return parcel;
    }

    hasFormErrors(errors) {
        return !isUndefined(errors) && errors.selection;
    }

	compareRequestResults(r1, r2) {
		var r1Cost = r1.cost ? numeral(r1.cost).value() : null;
		var r1Error = r1.status === 'Error';

		var r2Cost = r2.cost ? numeral(r2.cost).value() : null;
		var r2Error = r2.status === 'Error';

		if (r1Error && !r2Error) {
			return 1;
		} else if (!r1Error && r2Error) {
			return -1;
		} else if (r1Cost !== null && r2Cost !== null) {
			if (r1Cost === r2Cost) {
				return 0;
			} else if (r1Cost < r2Cost) {
				return -1;
			} else {
				return 1;
			}
		} else if (r1Cost === null && r2Cost === null) {
			if (r1.name === r2.name) {
				return 0;
			} else if (r1.name < r2.name) {
				return -1;
			} else {
				return 1;
			}
		} else if (r2Cost === null) {
			return -1;
		} else {
			return 1;
		}
	}

	handleRequestsChange(costRequests) {		
		if (costRequests) {
			costRequests.sort(this.compareRequestResults);
		}
        return this.props.onFieldChange([
            {
                name: "carrierCostRequests",
                value: costRequests
			}
        ]);
    }

	clearCarrier() {
		this.props.onFieldChange([
            {
                name: "carrierId",
                value: null
            }
        ]);
		if (this.props.onFieldEdited) {
			this.props.onFieldEdited("carrierId", null);
		}
	}

    validateForm(fieldName) {
		var result = null;

		if (isUndefined(fieldName)) {
			if (!this.props.parcel.carrierCostRequests || this.props.parcel.carrierCostRequests.length === 0) {
				result = result ? result : {};
				result.selection = "Необходимо запросить актуальную стоимость";
			} else {
				var hasSelection = false;
				this.props.parcel.carrierCostRequests.forEach((entry, ind, arr) => {
					if (entry.isSelected) {
						hasSelection = true;
					}
				});
				if (!hasSelection) {
					result = result ? result : {};
					result.selection = "Необходимо выбрать один из вариантов доставки";
				}
			}

            if (this.props.parcel.isDeliveryTimeSpecified && !this.props.parcel.deliveryTime) {
                result = result ? result : {};
                result.deliveryTime = "Желаемая дата и время доставки является обязательным полем, если доставка к определенному времени запрошена";
            }

			if (this.props.parcel.deliveryTime && moment(this.props.parcel.deliveryTime).isBefore('1900-01-01')) {
                result = result ? result : {};
                result.deliveryTime = "Желаемая дата и время доставки имеет некорректное значение";
			} else if (this.props.parcel.departureDate 
						&& this.props.parcel.deliveryTime 
						&& moment(this.props.parcel.departureDate) > moment(this.props.parcel.deliveryTime)) {
                result = result ? result : {};
                result.deliveryTime = "Желаемая дата и время доставки не может быть раньше Даты отправки груза";
            }
		}

        return result;
    }

    addPending(carrier) {
		let newEntry = {
            carrierId: carrier.id,
            carrierName: carrier.name,
            carrierPublicOfferUrl: carrier.publicOfferUrl,
            status: 'Sent',
            isSelected: false
        };
		let newEntries = this.props.parcel.carrierCostRequests;
		newEntries.push(newEntry);
		this.handleRequestsChange(newEntries);
        return newEntry;
    }

    addSkipped(carrier) {
        let newEntry = {
            carrierId: carrier.id,
            carrierName: carrier.name,
            carrierPublicOfferUrl: carrier.publicOfferUrl,
			isDeliveryTimeSpecified: false,
			deliveryTime: '',
			minDeliveryTime: null,
			maxDeliveryTime: null,
            status: 'Skip',
            isSelected: false
        };
		let newEntries = this.props.parcel.carrierCostRequests;
		newEntries.push(newEntry);
		this.handleRequestsChange(newEntries);
        return newEntry;
    }

    saveResults(carrierId, newEntries) {
        newEntries.forEach((entry, ind, arr) => {
			entry.isDeliveryTimeSpecified = false;
			entry.deliveryTime = entry.maxDeliveryTime;
        });
        let newStateEntries = [];
        let isFirstEntry = true;
		let isUpdated = false;
        this.props.parcel.carrierCostRequests.forEach((oldEntry, ind, arr) => {
            if (oldEntry.carrierId === carrierId) {
                if (isFirstEntry) {
                    newStateEntries = newStateEntries.concat(newEntries);
                    isFirstEntry = false;
					isUpdated = true;
                }
            } else {
                newStateEntries.push(oldEntry);
            }
        });
		if (!isUpdated) {
            newStateEntries = newStateEntries.concat(newEntries);
		}
		this.handleRequestsChange(newStateEntries);
    }

    markAsFailed(entry, errorMessage) {
		var newEntry = null;
		let newEntries = this.props.parcel.carrierCostRequests;
        newEntries.forEach((stateEntry, ind, arr) => {
            if (stateEntry === entry) {
                stateEntry.status = 'Error';
                stateEntry.statusComment = errorMessage;
				newEntry = stateEntry;
            }
        });
		this.handleRequestsChange(newEntries);
    }

	getCostCalcRequest() {
        let parcelData = null;
		if (this.props.isNew) {
			parcelData = this.props.getParcelModel();
		} else {
			parcelData = this.props.parcel;
		}
        var costRequest = {
            companyId: parcelData.companyId,
			subCompanyId: parcelData.subCompanyId,
			departureDate: parcelData.departureDate,
			declaredCargoValue: parcelData.declaredCargoValue,
            parcelType: parcelData.parcelType,
            volume: parcelData.volume,
			weight: parcelData.weight,			
            packagesCount: parcelData.packagesCount,
            shipmentAddressId: parcelData.shipmentAddressId,
            shipmentAddress: parcelData.shipmentAddress,
            deliveryAddressId: parcelData.deliveryAddressId,
            deliveryAddress: parcelData.deliveryAddress,
			isReturnRequested: parcelData.isReturnRequested,
			isLoadingRequested: parcelData.isLoadingRequested,
			isPackagingRequested: parcelData.isPackagingRequested,
			isValueDeclared: parcelData.isValueDeclared,
			senderContactInfo: parcelData.senderContactInfo,
            recipientContactInfo: parcelData.recipientContactInfo,
            deliveryTypeCode: parcelData.deliveryTypeCode,
            extraServiceCodes: parcelData.services || [],
            positions: parcelData.positions || []
		};		
		if (parcelData.length !== null) {
			costRequest.length = parcelData.length;
		}
		if (parcelData.height !== null) {
			costRequest.height = parcelData.height;
		}
		if (parcelData.width !== null) {
			costRequest.width = parcelData.width;
		}
		if (!this.props.isNew) {
			costRequest.parcelId = this.props.parcel.id;
		}
        return costRequest;
    }

	initNewList() {
		this.clearCarrier();
		if (this.props.isNew) {
			return Promise.resolve();
		} else {
			return apiPost('parcels/cost/' + this.props.parcel.id + '/initNewList')
					.then(response => {
						response.costs.forEach((entry, ind, arr) => {
							this.saveResults(entry.carrierId, [entry]);
						});
					});
		}
	}

    sendRequests() {
		this.setState({tariffsUpdated: true});
        var costRequest = this.getCostCalcRequest();
        this.props.clearErrors();
		this.handleRequestsChange([])
			.then(() => {
				this.initNewList()
					.then(() => {
                        apiGet('parcels/cost/carriers/' + this.props.parcel.companyId)
							.then(response => {
								if (response.entries) {
									response.entries.forEach((entry, ind, arr) => {
										if (entry.hasIntegration) {
											let requestEntry = this.addPending(entry);
											apiPost('parcels/cost/calc/' + entry.id, costRequest)
												.then(response => {
													if (response.isComplete) {
														this.saveResults(entry.id, response.costs);
														$('[data-toggle="popover"]').popover();
													}	
												})
												.catch(err => {
													let errorMessage = err.messages ? err.messages.request : null;
													this.markAsFailed(requestEntry, errorMessage);
												});
										} else if (this.props.isNew) {
											this.addSkipped(entry);
										}
									});
								}
							});
					});
			});
    }

	selectCostEntry(entry, confirmed) {
		if (entry.isRecipientCompanyRequired
			&& (!this.props.parcel.recipientCompanyName || this.props.parcel.recipientCompanyName.length == 0
				|| !this.props.parcel.recipientInn || this.props.parcel.recipientInn.length == 0)) {
			this.fillRecipientModal.open(this.props.parcel.recipientInn, this.props.parcel.recipientCompanyName)
				.then(data => {
					this.props.onFieldChange([
						{
							name: "recipientInn",
							value: data.recipientInn
						},
						{
							name: "recipientCompanyName",
							value: data.recipientCompanyName
						}
					])
					.then(() => this.selectCostEntry(entry));
				});
			return;
		}

		if (entry.tariff && entry.tariff.needConfirmation && !confirmed) {
			this.confirmModal.open("Выбор транспортной компании", entry.tariff.confirmationMessage, "Да", "Нет")
				.then(() => this.selectCostEntry(entry, true));
			return;
        }

		if (this.props.isNew) {
			this.props.clearErrors();
			let newEntries = this.props.parcel.carrierCostRequests;
			newEntries.forEach((stateEntry, ind, arr) => {
				stateEntry.isSelected = stateEntry === entry;
			});
			let fieldUpdates = [
				{
					name: 'carrierId',
					value: entry.carrierId
				},
				{
					name: 'isDeliveryTimeSpecified',
					value: entry.isDeliveryTimeSpecified
				},
				{
					name: 'deliveryTime',
					value: entry.isDeliveryTimeSpecified ? entry.deliveryTime : ''
				},
				{
					name: "carrierCostRequests",
					value: newEntries
				},
				{
					name: "carrierPublicOfferUrl",
					value: entry.carrierPublicOfferUrl
				}
			];
			if (entry.status === 'Skip') {
				fieldUpdates.push({
					name: 'deliveryCost',
					value: ''
				});
			} else {
				fieldUpdates.push({
					name: 'carrierServiceCode',
					value: entry.carrierServiceCode
				});
				fieldUpdates.push({
					name: 'carrierServiceName',
					value: entry.carrierServiceName
				});
				fieldUpdates.push({
					name: 'deliveryCost',
					value: entry.cost
				});
				fieldUpdates.push({
					name: 'rawDeliveryCost',
					value: entry.rawCost
				});
				fieldUpdates.push({
                    name: 'tariffRate',
                    value: entry.tariffRate
				});
				fieldUpdates.push({
					name: 'claimId',
					value: entry.claimId
				});
				fieldUpdates.push({
					name: 'version',
					value: entry.version
				});
			}
			this.props.onFieldChange(fieldUpdates);
		} else {
			let data = {
				parcelId: this.props.parcel.id,
				entryId: entry.id,
				isDeliveryTimeSpecified: entry.isDeliveryTimeSpecified,
				deliveryTime: entry.isDeliveryTimeSpecified ? entry.deliveryTime : '',
				recipientInn: this.props.parcel.recipientInn,
				recipientCompanyName: this.props.parcel.recipientCompanyName,
			};
			apiPost('parcels/cost/select', data)
				.then(() => {
					this.props.reload();
				});
		}
    }

	onSelectTariff() {
		const selectedTariff = this.state.selectTariffModal.tariff;
		this.props.onSave(selectedTariff);
	}

    renderTableForm() {
        const selectedServices = this.props.parcel.services || [];
        const tariffs = (this.props.parcel.carrierCostRequests || [])
            .filter(c => c.status !== 'Error')
            .map(tariff => {
                const servicesCost = (tariff.services || [])
                    .filter(service => selectedServices.includes(service.code))
                    .reduce((sum, service) => sum + (service.cost || 0), 0);
                const totalCost = (tariff.cost || 0) + servicesCost;
                return {
                    ...tariff,
                    cost: totalCost,
                    displayData: {
                        ...(tariff.displayData || {}),
                        cost: totalCost
                    }
                };
            });
        return (
			<ResultData
				isView={!this.isOnlyBeforeSendEditable(this.props)}
				tariffs={tariffs}
				form={{}}
				isCostCalc
				onClickSendBtn={(tariff) => this.setState({selectTariffModal: {open: true, tariff}})}
			/>
        );
    }

	isOnlyBeforeSendEditable(props) {
		let isCoordinator = getRoles().indexOf('Coordinator') >= 0;
		return props.isNew
			|| props.parcel.statusCode === "Created"
			|| (props.parcel.statusCode === "OnClientManager" && isCoordinator)
			|| (props.parcel.statusCode === "SentToMailRoom" && isCoordinator);
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		if(this.props.isOpen !== prevProps.isOpen) {
			if (this.props.isOpen && this.isOnlyBeforeSendEditable(this.props) && !this.state.tariffsUpdated) this.sendRequests();
		}
	}

	warningInfo(text) {
		return <div className='warning-info'>
			<div>
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M12 0C5.37248 0 0 5.37267 0 12C0 18.6277 5.37248 24 12 24C18.6275 24 24 18.6277 24 12C24 5.37267 18.6275 0 12 0ZM12 18C11.1715 18 10.5 17.3288 10.5 16.5C10.5 15.6716 11.1715 15 12 15C12.8285 15 13.5 15.6716 13.5 16.5C13.5 17.3288 12.8285 18 12 18ZM13.5 12.75H10.5L9.75 6.75C9.75 6.33581 10.0858 6 10.5 6H13.5C13.9142 6 14.25 6.33581 14.25 6.75L13.5 12.75Z" fill="#F57921"/>
				</svg>
			</div>
			<div className='text'>{text}</div>
		</div>
	}

	componentDidMount() {
		this.loadCompanyData();
	}

	loadCompanyData(){
		apiGet('user/company')
			.then(data => {
				this.setState({companyData: data});
			})
			.catch(err => {
			});
	}

	render() {
        let isOnlyBeforeSendEditable = this.isOnlyBeforeSendEditable(this.props);
        let data = this.renderTableForm();
		return (
			<div className='result-step'>
				<div className='result-step__table'>
					{isOnlyBeforeSendEditable && this.warningInfo('Необходимо выбрать один из вариантов доставки')}
					{data}
					<SelectTariffModal
						publicOfferUrl={(this.state.companyData || {}).publicOfferUrl || ''}
						parcel={this.props.parcel}
						setOpen={(open) => this.setState({selectTariffModal: {open}})}
						open={(this.state.selectTariffModal || {}).open}
						onConfirm={() => this.onSelectTariff()}
					/>
					<ConfirmModal ref={modal => this.confirmModal = modal} />
					<InformationModal ref={modal => this.infoModal = modal} />
					<FillRecipientCompanyModal ref={modal => this.fillRecipientModal = modal} />
				</div>
				<div className='result-step__settings'>
					<ActualCostBlock parcel={this.props.parcel} />
				</div>
			</div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/tabs/costCalcTab.jsx